import { render, staticRenderFns } from "./EditAssign.vue?vue&type=template&id=183765a5&scoped=true&"
import script from "./EditAssign.vue?vue&type=script&lang=js&"
export * from "./EditAssign.vue?vue&type=script&lang=js&"
import style0 from "./EditAssign.vue?vue&type=style&index=0&id=183765a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183765a5",
  null
  
)

export default component.exports